<template>
  <lila-default-template>
    <template #mainContent>
      <div class="bi-page">
        <h1 class="title">
          BI
        </h1>

        <p
          v-if="errorMessage"
          class="bi-message"
        >
          {{ errorMessage }}
        </p>

        <div
          v-else
          class="bi-frame-wrapper"
        >
          <iframe
            v-if="powerBIUrl"
            title="BI"
            :src="powerBIUrl"
            class="bi-frame"
            allowfullscreen
          />
          <p
            v-else
            class="bi-message"
          >
            Carregando…
          </p>
        </div>

        <div
          v-if="powerBIUrl && !errorMessage"
          class="bi-download-container"
        >
          <button
            type="button"
            class="bi-download-btn"
            :disabled="downloading"
            @click="downloadZip"
          >
            {{ downloading ? "Baixando…" : "Baixar Dados" }}
          </button>
        </div>
      </div>
    </template>
  </lila-default-template>
</template>

<script>
import DefaultTemplate from "@components/template/DefaultTemplate.vue";

export default {
  components: {
    "lila-default-template": DefaultTemplate
  },
  data() {
    return {
      powerBIUrl: "",
      errorMessage: "",
      downloading: false
    };
  },
  created() {
    this.fetchPowerBIUrl();
  },
  methods: {
    authHeader() {
      return {
        Authorization: `bearer ${
          this.$Session.get(this.$userSessionName).token.Value
        }`
      };
    },
    async fetchPowerBIUrl() {
      try {
        const res = await this.$axios.get("api/powerbi/geturl", {
          headers: this.authHeader()
        });
        const url = res.data;
        if (!url) {
          this.errorMessage =
            "A URL do BI não foi encontrada. Tente novamente mais tarde.";
        } else {
          this.powerBIUrl = url;
          this.errorMessage = "";
        }
      } catch (error) {
        if (error.response) this.$Utilities.verifyToken(error.response.status);
        this.errorMessage =
          "Ocorreu um erro ao carregar o BI. Tente novamente mais tarde.";
      }
    },
    async downloadZip() {
      try {
        this.downloading = true;

        const res = await this.$axios.get("api/export/export-all-tables", {
          headers: this.authHeader(),
          responseType: "blob"
        });

        // Nome do arquivo a partir do cabeçalho Content-Disposition.
        let fileName = "dados.zip";
        const disposition = res.headers["content-disposition"];
        if (disposition && disposition.indexOf("filename=") !== -1) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            fileName = matches[1].replace(/['"]/g, "");
          }
        }

        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        if (error.response) this.$Utilities.verifyToken(error.response.status);
        this.errorMessage =
          "Ocorreu um erro ao baixar os dados. Tente novamente mais tarde.";
      } finally {
        this.downloading = false;
      }
    }
  }
};
</script>

<style lang="scss">
$lila-primary: #4f3f82;

.bi-page {
  width: 100%;
  max-width: none;
  padding: 10px 24px 24px;
}

.bi-page .title {
  color: $lila-primary;
  font-weight: 700;
  margin-bottom: 16px;
}

/* Igual ao Lila Dashboard (.widgets): iframe ocupa tela cheia, dando espaço
   para o relatório do Power BI se distribuir sem comprimir/sobrepor. */
.bi-page .bi-frame-wrapper {
  width: 100%;
  max-width: 100vw;
  height: 100vh;
  overflow-x: hidden;
}

.bi-page .bi-frame {
  display: inline;
  width: 100%;
  height: 100%;
  aspect-ratio: 16 / 9;
  border: none;
  border-radius: 12px;
  background: #ffffff;
}

.bi-page .bi-message {
  color: #6b6b6b;
  font-size: 14px;
}

.bi-page .bi-download-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.bi-page .bi-download-btn {
  background-color: #9a397d;
  color: #ffffff;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
}

.bi-page .bi-download-btn:hover:not(:disabled) {
  background-color: #7a2d63;
}

.bi-page .bi-download-btn:disabled {
  opacity: 0.7;
  cursor: default;
}
</style>
